module.exports = __webpack_public_path__ + "img/comm-02-border-btm-01.9ee1007f.png";